import { Shield, Award, Clock, Languages, Building2, Stethoscope } from "lucide-react";

const trustIndicators = [
  {
    icon: Shield,
    title: "JCI Accredited",
    description: "All partner hospitals meet international quality standards",
  },
  {
    icon: Award,
    title: "Certified Doctors",
    description: "500+ specialists trained at top global institutions",
  },
  {
    icon: Clock,
    title: "24/7 Support",
    description: "Round-the-clock assistance in your language",
  },
  {
    icon: Languages,
    title: "Multilingual",
    description: "Support in English, Arabic, Russian & more",
  },
  {
    icon: Building2,
    title: "20+ Hospitals",
    description: "Network of premium healthcare facilities",
  },
  {
    icon: Stethoscope,
    title: "10,000+ Patients",
    description: "Successfully treated from 50+ countries",
  },
];

const accreditations = [
  "JCI (Joint Commission International)",
  "NABH (National Accreditation Board)",
  "ISO 9001:2015 Certified",
];

export function TrustSection() {
  return (
    <section id="about" className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-12 lg:mb-16">
          <span className="inline-block text-primary font-medium text-sm uppercase tracking-wider mb-4">
            Why Choose Us
          </span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-secondary mb-4">
            Trust That Travels With You
          </h2>
          <p className="text-foreground/70 text-lg">
            We combine the warmth of Indian hospitality with world-class medical expertise.
          </p>
        </div>

        {/* Trust Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 lg:gap-6 mb-16">
          {trustIndicators.map((indicator) => (
            <div
              key={indicator.title}
              className="bg-card rounded-lg p-6 shadow-soft text-center hover:shadow-hover transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
                <indicator.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="font-display font-semibold text-secondary mb-1 text-sm lg:text-base">
                {indicator.title}
              </h3>
              <p className="text-foreground/60 text-xs lg:text-sm">
                {indicator.description}
              </p>
            </div>
          ))}
        </div>

        {/* Accreditations */}
        <div className="bg-secondary rounded-lg p-8 lg:p-12">
          <div className="text-center mb-8">
            <h3 className="font-display text-2xl font-bold text-secondary-foreground mb-2">
              International Accreditations
            </h3>
            <p className="text-secondary-foreground/70">
              Our partner hospitals meet the highest global standards
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-4 lg:gap-8">
            {accreditations.map((accreditation) => (
              <div
                key={accreditation}
                className="bg-secondary-foreground/10 backdrop-blur-sm rounded-full px-6 py-3 text-secondary-foreground font-medium text-sm"
              >
                {accreditation}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
